import RouteModel from "../../../model-factory/basic/route/RouteModel";
import {FactoryID, RouteKey} from "../../../model-factory/type-interface/ModelFactoryType";
import RouteFactory from "../../../model-factory/basic/route/RouteFactory";
import RouteChoice from "../../../model-factory/basic/route/RouteChoice";
import {IRouteIDs} from "../../../model-factory/type-interface/ModelFactoryInterface";

export class MessageRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "message_route_id";
    goToFirstChild:boolean = true;
    choiceOrder:string[] = ["search", "list"];
}

export default class MessageRouteFactory extends RouteFactory
{

    id: FactoryID = "message_route";

    constructor()
    {
        super();

        this.choices = {
            search: new RouteChoice({
                name: "Inbox",
                publicID: "inbox",
                nextFactoryID: "message_page_list_route",
            }),
            list: new RouteChoice({
                name: "Messages",
                publicID: "messages",
                nextFactoryID: "message_list_route",
            })
        }
    }

    birth(id: FactoryID): MessageRouteModel
    {
        return new MessageRouteModel(id);
    }

    getDefaultModel(): MessageRouteModel
    {
        return this.getDefaultModelWithRoute()! as MessageRouteModel;
    }

    defaultRouteIDs(): IRouteIDs
    {
        return {
            account_route_id : "message",
            browse_route_id : "account"
        };
    }
}